import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { default_invite } from '../services';
import { Staffs, StaffsFilters } from '../types';

export default class StaffState extends BaseState {
  staffs: Staffs.Staff[] = [];

  staff_loading = false;

  current_staff: Staffs.Staff = {} as Staffs.Staff;

  cities: string[] = [];

  filters: StaffsFilters = {
    search: '',
    role: [],
    status: null,
    city: '',
  }

  new_staff_invite = default_invite();

  staff_for_role_changing: Staffs.Staff = {} as Staffs.Staff;

  changing_info: Staffs.ChangingInfo = {
    staff_id: 0,
    code: null,
  }

  transfer_role_error_message = ''

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['full_name'],
    sortDesc: [false],
  };

  all_staffs = false;
}
